import request from '@/utils/request'

export function createCatalogue(data) {
    return request({
      url: 'product/createCatalogue',
      method: 'post',
      data
    })
  }
  